import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import {QRTagGenerationWithFactory } from './Pages';

export const QRTagGenerationWithFactoryRoutes = ({ match }) => (
    <Fragment>
        <Route exact path = {`${match.path}`} component={QRTagGenerationWithFactory} />
       
    </Fragment>
)